import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@fortawesome/fontawesome-free/css/all.css";
import { createVuetify } from "vuetify";
import "vuetify/styles"; // Vuetify CSS

const vuetify = createVuetify();

createApp(App).use(store).use(router).use(vuetify).mount("#app");
